import {Injectable} from '@angular/core';
import {AuthService} from './api/auth.service';
import {Subject} from 'rxjs';
import {DatePipe} from '@angular/common';

@Injectable({
    providedIn: 'root',
})
export class TokenService {
    EXPIRES_IN = 'expires_in';
    ACCESS_TOKEN = 'access_token';

    tokenExpires;
    timeOut;
    public subAppInitiated:Subject<boolean> = new Subject()
    constructor(
        protected authService: AuthService,
        protected datePipe: DatePipe,
    ) {
    }

    startTimer(): void {
        const exp = localStorage.getItem(this.EXPIRES_IN);
        this.tokenExpires = exp !== undefined ? exp : 0;

        const ch = new Date(this.tokenExpires);

        const dateNow = new Date();

        if ((+ch - +dateNow) / 1000 / 60 <= 0) {
            this.clearToken();
            clearInterval(this.timeOut);
        } else {
            this.timeOut = setTimeout(() => this.startTimer(), (+ch - +dateNow) - 10000);
            this.rewriteToken();
        }
    }

    setToken(accessToken: string, expiresIn: string = null): void {
        if (accessToken.length) {
            if (accessToken.substring(0, 6) !== 'Bearer') {
                accessToken = 'Bearer ' + accessToken;
            }
            localStorage.setItem(this.ACCESS_TOKEN, accessToken);
        }

        if (expiresIn) {
            const today = new Date();
            today.setMinutes(today.getMinutes() + (6900 / 60));
            const pipeToday = this.datePipe.transform(today, 'yyyy-MM-ddTHH:mm:ss.SSS');

            localStorage.setItem(this.EXPIRES_IN, pipeToday);
        }
    }

    getToken(): string {
        return localStorage.getItem(this.ACCESS_TOKEN);
    }
    getExpireTime(): string {
        return localStorage.getItem(this.EXPIRES_IN)||'';
    }

    clearToken(): void {
        localStorage.removeItem(this.ACCESS_TOKEN);
        localStorage.removeItem(this.EXPIRES_IN);
        sessionStorage.clear();
    }

    rewriteToken(): Subject<boolean> {
        const sbj: Subject<boolean> = new Subject<boolean>();
        this.authService.updateAccessToken().pipe().subscribe(data => {
            this.setToken(data.access_token, data.expires_in);
            sbj.next(true);
        });
        return sbj;
    }

    checkToken(): boolean {
        const token = localStorage.getItem(this.ACCESS_TOKEN);
        const exp = localStorage.getItem(this.EXPIRES_IN);

        let isTokenFresh = !!(token && exp);

        if (!isTokenFresh) {
            const ch = new Date(this.tokenExpires);
            const dateNow = new Date();

            isTokenFresh = ((+ch - +dateNow) / 1000 / 60 <= 0);
        }
        return isTokenFresh;
    }
}
